<template>
    <div class="btns product-order-btns">
        <button type="button" class="btn-l btn-p w-100" ga-attr-btn=”estimate-download” @click="downloadEstimate()">견적서 다운로드</button>
        <div role="dialog" hidden>
            <div ref="pdfArea" :key="pdfKey">
                <div class="pdf">
                    <div class="pdf-header">
                        <!-- <img class="logo-img" src="@/assets/img/logo.svg" alt="YESCON"> -->
                        <LogoYescon></LogoYescon>
                        <h2><strong>티사이언티픽</strong> 온라인 견적서</h2>
                    </div>
                    <div class="pdf-body">
                        <section class="company">
                            <div class="company-item">
                                <p class="item-title">주문정보</p>
                                <table class="company-table">
                                    <tr>
                                        <th>기업명</th>
                                        <td>
                                            {{estimateOrdererCompany}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>부서명</th>
                                        <td>
                                            {{estimateOrdererTeam}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>견적일자</th>
                                        <td><p>{{estimateOrderDate}}</p>
                                            <p class="color-warning mt-2">특별할인 행사의 종료, 정상단가의 인상, 브랜드 사정에 의한 공급 중단 등의 사유로 견적 내용에 변동이 발생할 수 있습니다.</p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="company-item">
                                <p class="item-title">공급자</p>
                                <table class="company-table">
                                    <tr>
                                        <th>상호</th>
                                        <td>주식회사 티사이언티픽</td>
                                    </tr>
                                    <tr>
                                        <th>대표자명</th>
                                        <td>김상우, 유승재</td>
                                    </tr>
                                    <tr>
                                        <th>업태</th>
                                        <td>통신업, 도소매, 서비스</td>
                                    </tr>
                                    <tr>
                                        <th>종목</th>
                                        <td>부가통신업, 인터넷상거래 외</td>
                                    </tr>
                                    <tr>
                                        <th>주소</th>
                                        <td>서울특별시 동작구 여의대방로62길 1, 3층(대방동, 이투데이빌딩)</td>
                                    </tr>
                                </table>
                            </div>
                        </section>
                        <section class="estimate">
                            <div class="estimate-cost">
                                <p>최종 견적 금액</p>
                                <p><span class="hangul">금 {{estimatePriceToKorean}}원</span><strong>{{Number(getTotalEstimatePrice).toLocaleString()}}</strong> 원</p>
                            </div>
                            <table class="estimate-table">
                                <thead>
                                    <tr>
                                        <th>상품</th>
                                        <th>유효기간</th>
                                        <th>정상단가</th>
                                        <th>할인율</th>
                                        <th>공급단가</th>
                                        <th>수량</th>
                                        <th>구매금액</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(pdfEstimatedItem, index) in vuexEstimateProductList" v-bind:key="index">
                                        <!-- <td class="product-img"><img :src="`${pdfEstimatedItem.blobImgUrl}`" :alt="`${pdfEstimatedItem.goodsNm}`" class="thumb-img"></td> -->
                                        <td class="product-name">
                                            <p aria-label="브랜드명"><strong>{{pdfEstimatedItem.brdNm}}</strong></p>
                                            <p aria-label="상품명">{{pdfEstimatedItem.goodsNm}}</p>
                                        </td>
                                        <td>{{pdfEstimatedItem.validDate}}</td>
                                        <td>{{Number(pdfEstimatedItem.goodsPriceMarket).toLocaleString()}}</td>
                                        <td>{{pdfEstimatedItem.discountRatio}}</td>
                                        <td>{{Number(pdfEstimatedItem.goodsPricePoc).toLocaleString()}}</td>
                                        <td>{{Number(pdfEstimatedItem.perAmountCntProduct).toLocaleString()}}</td>
                                        <td>{{Number(pdfEstimatedItem.perTotalProductOrderPrice).toLocaleString()}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <section class="summary">
                            <table class="summary-table">
                                <tr>
                                    <th>발송 수량 합계</th>
                                    <td>{{Number(getEstimateTotalCouponCnt).toLocaleString()}} 개</td>
                                </tr>
                                <tr>
                                    <th>상품 금액 합계</th>
                                    <td>{{Number(getTotalProductOrderPrice).toLocaleString()}} 원</td>
                                </tr>
                                <tr>
                                    <th>할인 금액 합계</th>
                                    <td>{{Number(getTotalProductDiscountPrice).toLocaleString()}} 원</td>
                                </tr>
                            </table>
                            <div class="summary-cost">
                                <span>최종 견적 금액</span>
                                <span>{{Number(getTotalEstimatePrice).toLocaleString()}} 원</span>
                            </div>
                        </section>
                        <section class="notice">
                            <p class="item-title">안내사항</p>
                            <ul class="notice-list">
                                <li>상품 발송은 MMS(일부상품 LMS)로 각 수신자의 휴대폰으로 전송됩니다.</li>
                                <li>기업 고객 프로모션 용으로 발송된 모바일 쿠폰은 공정거래위원회 신유형 상품권 표준약관에 의거하여 유효기간 연장이나 환불 대상이 아닙니다.</li>
                                <li>견적서 상 상품은 견적일자 기준으로 서비스 운영되고 있는 상품으로, 브랜드사의 요청에 의해 정상단가 변경 또는 추가 공급이 중단될 수도 있습니다.</li>
                                <li>본 견적서는 수신자 번호(휴대폰 번호) 1개당 쿠폰 1개 발송 기준입니다. (하나의 수신자번호로 복수의 쿠폰 발송이 필요한 경우 ’대량 견적문의하기’로 별도 문의 주시기 바랍니다.)</li>
                                <li>본 견적서는 발급일로부터 30일간 유효합니다.</li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex';
import { getNowDate } from '@/util';
export default {
    components: {
        LogoYescon: () => import('@/components/svg-icon/LogoYescon.vue')
    },

    props: {
        estimateOrdererCompany : {
            type: String
        },
        estimateOrdererTeam : {
            type: String
        }
    },

    computed: {
        ...mapState({
            userNo: state => state.userNo,
            vuexEstimateProductList: state => state.estimateStore.vuexEstimateProductList,
        }),
        ...mapGetters({
            getTotalProductOrderPrice:'estimateStore/getTotalProductOrderPrice',       // 상품 금액 합계
            getTotalProductDiscountPrice:'estimateStore/getTotalProductDiscountPrice', // 할인 차액 합계
            getEstimateTotalProductCnt:'estimateStore/getEstimateTotalProductCnt',     // 견적서 총 상품 수량
            getEstimateTotalCouponCnt:'estimateStore/getEstimateTotalCouponCnt',       // 견적서 총 쿠폰 수량 
            getTotalEstimatePrice:'estimateStore/getTotalEstimatePrice',               // 최종견적금액
        }),
        // 견적일자
        estimateOrderDate(){
            const now = new Date();
            const dateKorean = now.toLocaleString('ko-KR');
            const time = dateKorean.slice(-12);
            return dateKorean.replace(time, '');
        },
        estimatePriceToKorean() {
            return this.convertNumToKorean(this.getTotalEstimatePrice);
        },
        //견적서 파일명 생성
        createPdfFileName() {
            let pdfTitleResult = 'YESCON_' + getNowDate();
            return pdfTitleResult;
        },
    },

    data(){
        return{
            visiblePdf: false,
            pdfKey: 0,
            estimateOrdererManager: '',             // pdf 데이터 - 담당자명
            pdfEstimatedProductList: [],            // pdf 데이터 - 상품 리스트
            pdfTotalAmountNumProductCoupons: 0,     // pdf 데이터 - 발송 수량 합계
            pdfTotalAmountGoodsPriceMarket: 0,      // pdf 데이터 - 상품 금액 합계 (정상가 총액)
            pdfTotalAmountGoodsPriceDiffer: 0,      // pdf 데이터 - 할인 차액 합계
            pdfTotalAmountGoodsPricePoc: 0,         // pdf 데이터 - 최종 견적 금액
            koreanTotalAmountGoodsPricePoc: 0,      // 최종 견적 금액 한글변환
        }
    },

    mounted() {
        this.pdfEstimatedProductList = this.vuexEstimateProductList;
        this.pdfTotalAmountNumProductCoupons = this.getEstimateTotalCouponCnt;
        this.pdfTotalAmountGoodsPriceMarket = this.getTotalProductOrderPrice;
        this.pdfTotalAmountGoodsPriceDiffer = this.getTotalProductDiscountPrice;
        this.pdfTotalAmountGoodsPricePoc = this.getTotalEstimatePrice;
        this.koreanTotalAmountGoodsPricePoc = this.convertNumToKorean(this.getTotalEstimatePrice);
    },

    methods: {
        // 견적서 PDF 생성 실행
        downloadEstimate() {
            if(!this.estimateOrdererCompany) {
                alert('회사명은 필수 입력값입니다.');
                return;
            } else {
                if(Array.isArray(this.vuexEstimateProductList) && this.vuexEstimateProductList.length) {
                    const name = this.createPdfFileName;
                    this.$htmlToPdf(this.$refs.pdfArea, name);
                    this.pdfKey += 1;
                } else {
                    alert('견적서에 상품이 존재하지 않습니다.');
                    return;
                }  
            }
        },

         // 숫자를 한글 표기로 변환
        convertNumToKorean(num){
            num = parseInt((num + '').replace(/[^0-9]/g, ''), 10) + '';  // 숫자를 문자열로 변환  
            
            if(num == '0') return '영';
            const number = ['영', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];  // 한글화된 숫자
            const bigDigits = ['', '만', '억', '조'];           // 4개의 자리수로 구성된 큰 단위 레벨의 자리수 이름 (올림차순)
            const smallDigits = ['천', '백', '십', ''];         // 큰 단위 내부 작은 단위 레벨의 자리수 이름 (내림차순)
            const result = [];                                  //변환된 값을 저장할 배열  
            
            const numBigDigitsCnt = Math.ceil(num.length / 4);     // 큰 단위 개수
            num = num.padStart(numBigDigitsCnt * 4, '0');          // 큰 단위 내부 비어있는 자리수를 '0'으로 채움
            
            const arrayPerBigDigits = num.match(/[\w\W]{4}/g);  // 큰 단위 기준으로 분리한 배열

            // 낮은 자리수에서 높은 자리수 순으로 값을 만들어야 자리수 계산이 편하다
            for(let i = arrayPerBigDigits.length - 1, numBigDigitsCnt = 0; i >= 0; i--, numBigDigitsCnt++){
                let koreanVal = addNumUnitsTosmallDigits(arrayPerBigDigits[i]);
                
                if(koreanVal == '') // 빈값은 해당 단위 값이 모두 0
                    continue;
                
                result.unshift(koreanVal + bigDigits[numBigDigitsCnt]);
            }

            // 4자리 이내 문자열 숫자를 일십백천으로 표기
            function addNumUnitsTosmallDigits(text) {
                let str = '';
                for(let i = 0; i < text.length; i++){
                    let num = text[i];

                    if(num == '0') // 0은 제외
                        continue;

                    str += number[num] + smallDigits[i];
                }
                return str;
            }

            return result.join('');
        },

    },
}
</script>

<style lang="scss" scoped>
    .layerpopup-pdf{
        position: fixed;
        z-index: 2000000;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .3);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 10% 10% 5%;
        overflow: scroll;
    }

    .pdf{
        background: #fff;
        color: #000;
        font-size: 14px;
        letter-spacing: -0.8px;
        word-break: keep-all;

        .pdf-header{
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 12px;
            background: #edf0fa;

            .logo-img{
                width: 40px;
            }

            h2{
                font-size: 20px;
            }
        }

        .pdf-body{
            padding: 12px 12px 14px;
            display: flex;
            flex-direction: column;
            gap: 16px;

            @mixin section{
                display: flex;
                flex-direction: column;
                gap: 16px;
            }

            .company{
                display: flex;
                gap: 16px;

                .company-item{
                    flex: 1;

                    display: flex;
                    flex-direction: column;

                    .item-title{
                        font-size: 16px;
                        font-weight: 600;
                        padding: 10px 0 7px;
                    }

                    .company-table{
                        flex: 1;

                        width: 100%;
                        border-top: 2px solid #000;

                        @mixin cell{
                            border-bottom: 1px solid var(--gray-20);
                            padding: 7px 0;
                            min-width: 80px;
                        }

                        th{
                            @include cell();
                            font-weight: 500;
                        }
                        td{                            
                            @include cell();
                        }
                    }
                }
            }

            .estimate{
                @include section();

                .estimate-cost{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 20.5px 12px;
                    background: #edf0fa;
                    border-radius: 4px;
                    font-size: 18px;
                    font-weight: 600;

                    .hangul{
                        font-size: 14px;
                        margin-right: 20px;
                    }
                }

                .estimate-table{
                    width: 100%;
                    border-top: 2px solid #000;

                    @mixin cell{                        
                        padding: 9px 4px;
                        border: 1px solid var(--gray-20);
                        text-align: center;
                        min-width: 50px;

                        &:first-child{
                            border-left: none;
                        }
                        &:last-child{
                            border-right: none;
                        }
                    }

                    th{
                        @include cell();
                        background-color: var(--gray-10);
                    } 
                    td{
                        @include cell();
                                                
                        &.product-img{
                            width: 40px;
                            border-right: none;

                            .thumb-img{
                                width: 32px;
                            }
                        }
                        &.product-name{
                            border-left: none;
                            text-align: left;
                        }
                    }
                }
            }

            .summary{
                @include section();
                
                .summary-table{
                    margin-left: auto;
                    width: 240px;
                    th{
                        font-weight: 400;
                    }
                    td{
                        text-align: right;
                    }
                }

                .summary-cost{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 12px;
                    border-radius: 4px;
                    background: var(--gray-10);
                    font-size: 18px;
                    font-weight: 600;
                }

            }

            .notice{
                @include section();
                
                background: var(--gray-10);
                padding: 12px;
                border-radius: 4px;

                .item-title{                
                    font-size: 16px;
                    font-weight: 600;
                }

                .notice-list{
                    li{
                        display: flex;
                        gap: 4px;
                        &::before{
                            content: '· ';
                            display: flex;
                        }
                        font-size: 14px;
                        font-weight: 500;
                    }
                }
            }
        }
    }
</style>